import {
    useStyles,
    Caption,
    Checkbox,
    pxToRem,
    useTheme,
} from '@archipro-design/aria';

import * as S from './FilterContainer.mobile.style';
import type { ViewProjectsByOption } from '~/modules/search/hook/use-view-projects-by';

export interface FilterViewProjectsByProps {
    viewProjectsByOptions: ViewProjectsByOption[];
    onViewProjectsByChange: (value: ViewProjectsByOption['value']) => void;
}

const FilterViewProjectsBy = ({
    viewProjectsByOptions,
    onViewProjectsByChange,
}: FilterViewProjectsByProps) => {
    const theme = useTheme();
    const { css } = useStyles();

    return (
        <div className={css(S.ViewProjectsByContainer)}>
            <Caption variant="03" className="view-projects-by-title">
                {`VIEW PROJECTS BY`}
            </Caption>
            {viewProjectsByOptions.map((s) => {
                return (
                    <Checkbox
                        key={s.value}
                        checked={s.selected}
                        onChange={() => {
                            onViewProjectsByChange(s.value);
                        }}
                        indicator={{
                            kind: 'radio',
                            indicator: {
                                variables: {
                                    border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
                                    size: pxToRem(14),
                                    checkedBackgroundColor:
                                        theme.siteVariables.colors
                                            .charcoal[250],
                                },
                            },
                        }}
                        label={{
                            children: s.name,
                            variables: {
                                fontSize: pxToRem(16),
                                letterSpacing: 'normal',
                            },
                        }}
                        variables={{
                            labelLineHeight: pxToRem(40),
                            radioIndicatorLabelGap: pxToRem(6),
                            radioIndicatorLabelCheckedGap: pxToRem(6),
                        }}
                    />
                );
            })}
        </div>
    );
};

export default FilterViewProjectsBy;
